// FETCH ALL PROPERTIES FROM YARN_PO DETAILS
export const FETCH_YARN_PO_DETAILS_REQUEST = 'FETCH_YARN_PO_DETAILS_REQUEST';
export const FETCH_YARN_PO_DETAILS_SUCCESS = 'FETCH_YARN_PO_DETAILS_SUCCESS';
export const FETCH_YARN_PO_DETAILS_FAILURE = 'FETCH_YARN_PO_DETAILS_FAILURE';

export const FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_REQUEST = 'FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_REQUEST';
export const FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_SUCCESS = 'FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_SUCCESS';
export const FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_FAILURE = 'FETCH_YARN_PO_DETAILS_APPROVAL_STATUS_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_DETAILS_GROUP_LIST_REQUEST = 'FETCH_YARN_PO_DETAILS_GROUP_LIST_REQUEST';
export const FETCH_YARN_PO_DETAILS_GROUP_LIST_SUCCESS = 'FETCH_YARN_PO_DETAILS_GROUP_LIST_SUCCESS';
export const FETCH_YARN_PO_DETAILS_GROUP_LIST_FAILURE = 'FETCH_YARN_PO_DETAILS_GROUP_LIST_FAILURE';

// FETCH ALL PROPERTIES FROM YARN_PO DETAILS BY ID
export const FETCH_YARN_PO_DETAILS_BY_ID_REQUEST = 'FETCH_YARN_PO_DETAILS_BY_ID_REQUEST';
export const FETCH_YARN_PO_DETAILS_BY_ID_SUCCESS = 'FETCH_YARN_PO_DETAILS_BY_ID_SUCCESS';
export const FETCH_YARN_PO_DETAILS_BY_ID_FAILURE = 'FETCH_YARN_PO_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR YARN_PO DETAILS
export const CREATE_YARN_PO_DETAILS_REQUEST = 'CREATE_YARN_PO_DETAILS_REQUEST';
export const CREATE_YARN_PO_DETAILS_SUCCESS = 'CREATE_YARN_PO_DETAILS_SUCCESS';
export const CREATE_YARN_PO_DETAILS_FAILURE = 'CREATE_YARN_PO_DETAILS_FAILURE';

export const FETCH_YARN_PO_PREVIOUS_LIST_REQUEST = 'FETCH_YARN_PO_PREVIOUS_LIST_REQUEST';
export const FETCH_YARN_PO_PREVIOUS_LIST_SUCCESS = 'FETCH_YARN_PO_PREVIOUS_LIST_SUCCESS';
export const FETCH_YARN_PO_PREVIOUS_LIST_FAILURE = 'FETCH_YARN_PO_PREVIOUS_LIST_FAILURE';

export const FETCH_YARN_PO_UPDATE_LIST_REQUEST = 'FETCH_YARN_PO_UPDATE_LIST_REQUEST';
export const FETCH_YARN_PO_UPDATE_LIST_SUCCESS = 'FETCH_YARN_PO_UPDATE_LIST_SUCCESS';
export const FETCH_YARN_PO_UPDATE_LIST_FAILURE = 'FETCH_YARN_PO_UPDATE_LIST_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_YARN_PO_DETAILS = 'CREATE_USER_FORM_YARN_PO_DETAILS';

// UPDATE PROPERTIES FOR YARN_PO DETAILS
export const UPDATE_YARN_PO_DETAILS_REQUEST = 'UPDATE_YARN_PO_DETAILS_REQUEST';
export const UPDATE_YARN_PO_DETAILS_SUCCESS = 'UPDATE_YARN_PO_DETAILS_SUCCESS';
export const UPDATE_YARN_PO_DETAILS_FAILURE = 'UPDATE_YARN_PO_DETAILS_FAILURE';

// FETCH SINGLE YARN_PO_DETAILS
export const FETCH_SINGLE_YARN_PO_DETAILS_REQUEST = 'FETCH_SINGLE_YARN_PO_DETAILS_REQUEST';
export const FETCH_SINGLE_YARN_PO_DETAILS_SUCCESS = 'FETCH_SINGLE_YARN_PO_DETAILS_SUCCESS';
export const FETCH_SINGLE_YARN_PO_DETAILS_FAILURE = 'FETCH_SINGLE_YARN_PO_DETAILS_FAILURE';

// DELETE PROPERTIES FOR YARN_PO DETAILS
export const DELETE_YARN_PO_DETAILS_REQUEST = 'DELETE_YARN_PO_DETAILS_REQUEST';
export const DELETE_YARN_PO_DETAILS_SUCCESS = 'DELETE_YARN_PO_DETAILS_SUCCESS';
export const DELETE_YARN_PO_DETAILS_FAILURE = 'DELETE_YARN_PO_DETAILS_FAILURE';

// USERFORM RESET

export const YARN_PO_DETAILS_USERFORM_RESET = 'YARN_PO_DETAILS_USERFORM_RESET';
export const YARN_PO_DETAILS_USERFORM_SELECTED_ROWS = 'YARN_PO_DETAILS_USERFORM_SELECTED_ROWS';

export const UPDATE_YARN_PO_REQUEST = 'UPDATE_YARN_PO_REQUEST';
export const UPDATE_YARN_PO_SUCCESS = 'UPDATE_YARN_PO_SUCCESS';
export const UPDATE_YARN_PO_FAILURE = 'UPDATE_YARN_PO_FAILURE';

export const RESET_USERFORM_DATA = 'RESET_USERFORM_DATA'


export const MILL_NAME_REQUEST = 'MILL_NAME_REQUEST';
export const MILL_NAME_SUCCESS = 'MILL_NAME_SUCCESS';
export const MILL_NAME_FAILURE = 'MILL_NAME_FAILURE';

export const UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_REQUEST = 'UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_REQUEST';
export const UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_SUCCESS = 'UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_SUCCESS';
export const UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_FAILURE = 'UPDATE_YARN_PO_OUTSTANDING_REMARKS_DATA_FAILURE';
